// crewbit-admin/src/pages/Money/Settings/Branding.tsx
//
// /money/settings/branding — Invoice branding sub-screen. Sibling pattern
// of Paid.tsx / Taxes.tsx / People.tsx / Notifications.tsx.

import { useEffect } from 'react';
import { PageHeader } from '../../../components/common/PageHeader';
import BrandingPanel from '../../../components/money/settings/BrandingPanel';
import { useActiveBusinessStore } from '../../../hooks/useActiveBusiness';
import { admin, spacing } from '../../../styles/tokens';

const pageStyle: React.CSSProperties = {
  padding: spacing.xl,
  background: admin.bg,
  minHeight: '100vh',
};

export function MoneySettingsBranding() {
  const businessId = useActiveBusinessStore((s) => s.activeBusinessId);

  useEffect(() => {
    document.title = 'CrewBit · Invoice branding';
  }, []);

  return (
    <div style={pageStyle}>
      <PageHeader
        title="Invoice branding"
        description="Logo, accent colour, prefix, footer text, and e-transfer."
        back={{ to: '/money/settings', label: 'Money settings' }}
      />
      <BrandingPanel businessId={businessId} />
    </div>
  );
}
